export default "__VITE_ASSET__7156a6bb__"